import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { isEmpty } from 'underscore';
import Modal from 'react-modal';
import { Context } from '../../..';
import UserService from '../../../services/UserService';
import AskService from '../../../services/AskService';
import { QAModal } from './QAModal';
import { Trans } from '@lingui/macro';
import { ModalPopover } from './modal-popover';



const QA: FC<any> = observer(({ item, setQAModal, setQAID, setDelId, setDelModal }) => {

    return (
        <div className="col-md-2 mt-2 mb-5">
            <div style={{ cursor: "pointer" }} onClick={() => {
                setQAModal(true);
                setQAID(item['id']);
            }}>
                <hr />
                <div className="mb-2">
                    {!isEmpty(item['answers']) ? <i className='icon check' /> : <i className='icon wait' />}
                    <em>
                        {new Date(item['question_date']).toLocaleDateString("ru-RU", {
                            hour: 'numeric',
                            minute: 'numeric',
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                        })}
                    </em>
                </div>
                <div className="mb-2">
                    <h6>{item['subject'].substring(0, 100) + (item['subject'].length < 100 ? '' : '...')}</h6>
                </div>
                <div className="mb-2">
                    <em>{item['fio']}</em>
                </div>
            </div>
            <div onClick={() => {
                setDelId(item['id']);
                setDelModal(true);
            }}>
                <i className='icon trash ms-3' />
                <Trans>Delete</Trans>
            </div>
        </div>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const QuestionsListModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context)
    const [qaModal, setQAModal] = useState<boolean>(false);
    const [qaID, setQAID] = useState<any>({});
    const [specializations, setSpecializations] = useState<[]>([]);
    const [specTitle, setSpecTitle] = useState<string[]>([]);
    const [organizations, setOrganizations] = useState<[]>([]);
    const [orgTitle, setOrgTitle] = useState<string[]>([]);
    const [fix, setFix] = useState(true);
    const [delId, setDelId] = useState<number>(-1);
    const [delModal, setDelModal] = useState<boolean>(false);
    const quan = toJS(store.qa)


    useEffect(() => {
        if (!isEmpty(specializations)) {
            setSpecTitle([]);
            // eslint-disable-next-line array-callback-return
            specializations.forEach(item => {
                // eslint-disable-next-line array-callback-return
                store.specInfo.specializations?.forEach((sid: any) => {
                    if (item['id'] === sid) {
                        setSpecTitle(specTitle => [...specTitle, item['specialization']]);
                    }
                });
            });
        };
        if (!isEmpty(organizations)) {
            setOrgTitle([]);
            // eslint-disable-next-line array-callback-return
            organizations.forEach(item => {
                // eslint-disable-next-line array-callback-return
                store.specInfo.organizations?.forEach((sid: any) => {
                    if (item['id'] === sid) {
                        setOrgTitle(orgTitle => [...orgTitle, item['organization']]);
                    }
                });
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specializations, organizations]);

    const getSpecializations = async () => {
        const res = await UserService.getSpecializations('');
        setSpecializations(res.data.results);
    };

    const getOrganizations = async () => {
        const res = await UserService.getOrganizations('');
        setOrganizations(res.data.results);
    };

    const getQA = async () => {
        const qa = await AskService.getAllQuestions();
        store.setQA(qa.data.results);
    };

    const deleteQA = async () => {
        await AskService.deleteQA(delId);
        setDelModal(false);
        setDelId(-1);
        setFix(true);
    };

    useEffect(() => {
        getQA();
        getSpecializations();
        getOrganizations();
        setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix])

    const getItems = () => quan?.sort((a: any, b: any) => b['id'] - a['id']).map((item: any, i: number) => {
        return <QA key={i} {...{ item, setQAModal, setQAID, setDelId, setDelModal }} />
    })

    const onRequestClose = () => {
        setToggle(false);
    };

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className='row'>
                    {getItems()}
                    <QAModal toggle={qaModal} setToggle={setQAModal} qaID={qaID} spec={specTitle} org={orgTitle} />
                </div>
            </form>
            <ModalPopover
                toggle={delModal}
                setToggle={setDelModal}
                title={store.lang === 'ba' ? 'Һорауҙы алып ташлау' : store.lang === 'ru' ? 'Удаление вопроса' : 'Deleting a question'}
                modalContent={<Trans>Do you want to delete a question?</Trans>}
                clickedButtonOne={() => deleteQA()}
                clickedButtonTwo={() => { setDelModal(false); setDelId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </Modal >
    );
});